import { RouteConfig } from "vue-router";
import { RouteConfigSingleView } from "vue-router/types/router";

import Localization, { LOCALES } from '@/localization'

const ROUTE_LOCALE_DELIMITER: string = '|'

export const LOCAL_STORAGE_LOGIN_REMEMBERED_ROUTE: string = 'login-remebered-route'

export interface ILocalizedRouteParameters {
  name: string;
  locale: LOCALES;
}

export function generateLocalizedRouteName(parameters: ILocalizedRouteParameters): string {
  return `${parameters.name}${ROUTE_LOCALE_DELIMITER}${parameters.locale}`
}

export function extractLocalizedRouteParameters(name: string): ILocalizedRouteParameters {
  const routeParameters: string[] = name.split(ROUTE_LOCALE_DELIMITER)

  return {
    name: routeParameters[0],
    locale: routeParameters[1] as LOCALES
  }
}

function generateLocalizedRoutePath(name: string, locale: LOCALES = LOCALES.FR): string {
  return Localization.i18next.t(`router.routes.${name}`, { lng: locale })
}

function localizeRouteConfigChildrenRecursive(childrens: Array<RouteConfig> | undefined, locale: LOCALES = LOCALES.FR): Array<RouteConfig> | undefined {
  if (!childrens) {
    return undefined
  }

  return childrens.reduce((routes: Array<RouteConfig>, children: RouteConfig) => {
    return [
      ...routes,
      {
        name: generateLocalizedRouteName({
          name: children.name as string,
          locale
        }),
        path: generateLocalizedRoutePath(children.name as string, locale),
        component: (children as RouteConfigSingleView).component,
        meta: {
          ...children.meta,
          locale
        },
        children: localizeRouteConfigChildrenRecursive(children.children, locale)
      } as RouteConfig
    ]
  }, [])
}

function localizeRouteConfig(config: RouteConfig): Array<RouteConfig> {
  return Object.values(Localization.LOCALES).reduce((routes: Array<RouteConfig>, locale: LOCALES) => {
    return [
      ...routes,
      {
        name: generateLocalizedRouteName({
          name: config.name as string,
          locale
        }),
        path: generateLocalizedRoutePath(config.name as string, locale),
        component: (config as RouteConfigSingleView).component,
        meta: {
          ...config.meta,
          locale
        },
        children: localizeRouteConfigChildrenRecursive(config.children, locale)
      } as RouteConfig
    ]
  }, [])
}

export default function localizeRouteConfigs(originalRoutes: Array<RouteConfig>): Array<RouteConfig> {
  return originalRoutes.reduce((routes: Array<RouteConfig>, route: RouteConfig) => {
    return [
      ...routes,
      ...localizeRouteConfig(route)
    ]
  }, [])
}